import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { HistoricoEstadoOperacaoGarantida, OperacaoGarantida } from "src/app/model/operacao-garantida.model";

@Component({
    selector: 'aba-historico',
    templateUrl: 'aba-historico.component.html',
    standalone: false
})
export class AbaHistoricoComponent implements OnChanges {
    @Input()
    public operacao:OperacaoGarantida;
    
    public historicos:HistoricoEstadoOperacaoGarantida[];
    
    ngOnChanges(changes: SimpleChanges): void {
        this.historicos = this.operacao?.detalhe?.historicos;
    }
}